<template>
  <footer>
    <div class="footer-main">
      <el-row class="container" type="flex" justify="space-between">
        <el-col :span="16">
          <el-row>
            <el-col :span="7">
              <dl>
                <dt>产品中心</dt>
                <dd>数字化营销</dd>
                <dd>ERP-企业资源计划系统</dd>
                <dd>MES-生产制造执行</dd>
                <dd>SRM-智能供应链</dd>
                <dd>WMS-仓储管理系统</dd>
                <dd>CPS数据采集</dd>
              </dl>
            </el-col>
            <el-col :span="7">
              <dl>
                <dt>构件式开发平台</dt>
                <!-- <dd>平台介绍</dd> -->
                <dd>CS开发平台</dd>
                <dd>BS开发平台</dd>
                <dd>APP开发平台</dd>
                <!-- <dd>客户案例</dd>
                <dd>深度定制ERP</dd>
                <dd>智能制造</dd>
                <dd>互联网+</dd> -->
              </dl>
            </el-col>
            <el-col :span="7">
              <dl>
                <dt>客户案例</dt>
                <dd>深度定制ERP</dd>
                <dd>智能制造</dd>
                <dd>互联网+</dd>
              </dl>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="8">
          <div class="scan">
            <img :src="scanSrc" alt />
          </div>
        </el-col>
      </el-row>
      <!-- <div class="footer-copyright"></div> -->
    </div>
  </footer>
</template>

<script>
export default {
  name: "HelloWorld",
  props: {
    msg: String
  },
  data() {
    return {
      scanSrc: require("../assets/images/getech/scan.png")
    };
  },
  created(){
    // if(this.$store.state.subject=="ali"){
    //   this.scanSrc =require("../assets/images/ali/scan.png")
    // }else if(this.$store.state.subject=="mobile"){
    //   this.scanSrc =require("../assets/images/mobile/scan.png")
    // }
    // else if(this.$store.state.subject=="unicom"){
    //   this.scanSrc =require("../assets/images/unicom/scan.png")
    // }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
